module.exports = __webpack_public_path__ + "img/co.3bb26714.svg";